import type { AutomationRulePartial } from './types';

/** Max length for rule name (matches DB schema: automation_rules.name String(255)) */
export const RULE_NAME_MAX_LENGTH = 255;

export const DEFAULT_RULE = (): AutomationRulePartial => ({
  name: 'New automation',
  description: '',
  enabled: true,
  triggerEvent: 'client_created',
  priority: 100,
  conditions: {
    logic: 'AND',
    rules: [],
  },
  actions: [],
});
